module.exports = __webpack_public_path__ + "media/images/locked-dd85cbca5d687d82cddc91372ca8a13b.png";